import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import {
  Typography, Container, makeStyles, Button,
} from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import BasePage from './BasePage';
import SeedAuthenticationRepository from '../repository/SeedAuthenticationRepository';

const useStyles = makeStyles(() => ({
  container: {
    minHeight: '100vh',
  },
  content: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
}));

const RawSeedNotFoundPage = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleClickHome = () => {
    history.push('/');
  };

  return (
    <Container disableGutters className={classes.container}>
      <div className={classes.content}>
        <Typography gutterBottom color="textPrimary">
          <FormattedMessage id="seed.notFound.text" />
        </Typography>
        <Button onClick={handleClickHome} variant="outlined" color="primary">
          <FormattedMessage id="seed.button.goToHome" />
        </Button>
      </div>
    </Container>
  );
};

const SeedNotFoundPage = ({ applicationName }) => (
  <BasePage
    titleId="seed.notFound.title"
    Component={RawSeedNotFoundPage}
    AuthenticationRepository={SeedAuthenticationRepository}
    applicationName={applicationName}
  />
);

SeedNotFoundPage.propTypes = {
  applicationName: PropTypes.string,
};

SeedNotFoundPage.defaultProps = {
  applicationName: 'react-seed',
};

export default SeedNotFoundPage;
